import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { EvcAuthService } from '@core/services/evc-auth.service';
import { ConfigurationService } from '@osc-utils/services/configuration.service';
import { LoggerService } from '@shared/services/logger.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppAccessGuard {
  #authService = inject(EvcAuthService);
  #router = inject(Router);
  #logger = inject(LoggerService);
  #configurationService = inject(ConfigurationService);

  public canActivateChild(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.#configurationService.isWebApp() ? this.checkApplicationAccess() : true;
  }
  public canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.#configurationService.isWebApp() ? this.checkApplicationAccess() : true;
  }

  private async checkApplicationAccess(): Promise<boolean | UrlTree> {
    try {
      const hasAccess = await firstValueFrom(this.#authService.hasAccessToApplication$);
      if (!hasAccess) {
        return this.#redirectUrl();
      }
      return hasAccess;
    } catch (error) {
      this.#logger.error('Unable to check application access', error);
      return this.#redirectUrl();
    }
  }

  #redirectUrl() {
    return this.#configurationService.isMobileApp()
      ? this.#router.createUrlTree(['/mobile/access-denied'])
      : this.#router.createUrlTree(['/access-denied']);
  }
}
